import { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { imagesLinks } from "../Constants/links";
import { FooterSection } from "../Components/LauncherPageComponent/launcherPageComponent";
import SDK from "../config";
import "../Components/styles/launcherPageComponent.css";
import TrackingScripts from "../Components/checkoutPageComponent/trackingComponent";
import postVisitorsData from "../Components/web/visitors";

const ReservationPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get("email");
  const navigate = useNavigate();
  const eventId = `event-${new Date().getTime()}`;
  // const saveRegion = localStorage.getItem("region") || "us";

  const [currRegion, setCurrRegion] = useState("");
  const DiscountedPrice = SDK.FB_PRICE - SDK.FB_DISOUNT_PRICE;
  const finalDiscountedPrice = Number(DiscountedPrice.toFixed(2));

  useEffect(() => {
    if (window.mootrack) {
      window.mootrack("Reservation Page", email);
    }

    // Lead Generation Tracker
    if (window.twq) {
      window.twq("event", "tw-qmokf-qmokh", {
        email_address: email,
      });
    }
    const region = localStorage.getItem("region");
    if (region === "uk" || region === "eu") {
      setCurrRegion(`${region}`);
    } else {
      setCurrRegion("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [regionText, setRegionText] = useState(SDK.REGION_CONFIG.us);

  const clickCountMeIn = () => {
    let pathToNav =
      currRegion !== ""
        ? `/${currRegion}/payment-checkout?email=${encodeURIComponent(email)}`
        : `/payment-checkout?email=${encodeURIComponent(email)}`;
    navigate(pathToNav);

    if (window.fbq) {
      window.fbq("track", "AddToCart", { event_id: eventId });
    }
    if (window.mootrack) {
      window.mootrack("AddToCart", email);
    }
    // if (window.ttq) {
    //   window.ttq.track("AddToCart", { event_id: eventId });
    // }

    // Add to Cart Tracker
    if (window.twq) {
      window.twq("event", "tw-qmokf-qmokj", {
        value: 5.0,
        currency: "USD",
      });
    }
    console.log("reservation page twq: ", window.twq);

    const lead = true;
    const addtocart = true;
    const purchase = false;
    const amount = null;
    const tagsString = "Android Website";
    postVisitorsData({
      email,
      lead,
      addtocart,
      purchase,
      amount,
      tags: tagsString,
    });
  };

  // Check if the current route is '/reservation'
  const isReservationRoute =
    location.pathname === "/reservation" ||
    location.pathname === "/eu/reservation" ||
    location.pathname === "/uk/reservation";

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 829);

  useEffect(() => {
    const saveRegion = (localStorage.getItem("region") || "us").toLowerCase();
    const region = SDK.REGION_CONFIG[saveRegion];
    setRegionText(region);
    console.log("region Text", regionText);

    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 829);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <TrackingScripts />
      <div style={{ overflow: "hidden" }}>
        <div className="reservation_page">
          <div className="text_part">
            <div className="reservation_logo">
              <div>
                <img
                  src={imagesLinks.logo}
                  className="navLogo"
                  style={{
                    paintOrder: "stroke fill",
                    fill: "black",
                    WebkitTextStroke: "12px black",
                  }}
                  alt=""
                />
              </div>
            </div>

            <div className="text_box">
              <p className="pa1">
                Welcome! Get 40% off your first year for{" "}
                {regionText.currSymbol ?? "$"}
                {finalDiscountedPrice}
                &nbsp;
                {(regionText.currency ?? "USD").toUpperCase()}
              </p>

              <p className="pa3">
                Today's your lucky day! We charge $49.99 yearly on the app
                store.
              </p>
              <p className="pa3">
                For less than a cup of coffee ($2.50), save up to 120 hours
                every month.
              </p>
              <p className="pa3">
                Get a dumbphone experience for a fraction of the cost, without
                sacrificing the utility of your smartphone or needlessly
                polluting the environment.
              </p>

              {/* <p className="pa3">
                Offer ends as soon as Apple approves our full launch, ETA within
                a month. We plan on charging new users $49 yearly once we fully
                launch.
              </p>
              <p className="pa3">
                Some early access spots may open on a first come, first serve
                basis.
              </p>
              <p className="pa3">
                Just a cup of coffee to save up to 120 hours every month.
              </p>
               */}
              {/* <p className="pa3">
                Why do we bother with such a steep discount? It helps support
                our early development, and we like to reward early birds.
              </p> */}
              <button onClick={clickCountMeIn}>Redeem my discount</button>
            </div>
          </div>
          <div
            className={`cards_part ${
              isReservationRoute ? "reservation-specific" : ""
            }`}
          >
            <div className="img_text_box">
              <div className="card-img-text-box">
                <div className="card-team-img">
                  <img src={imagesLinks.iphoneMockup} alt="" />
                </div>
                <div className="card-text-box">
                  <div className="card-text-first-box">
                    <p>
                      Join 15,000+ others who have reclaimed control over their
                      phones:
                    </p>
                  </div>
                  <div className="card-text-second-box">
                    <ul>
                      <li>
                        <span className="bold-text">‘Am loving it!’</span> -
                        Gavin
                      </li>
                      <li>
                        <span className="bold-text">
                          ‘I love love love the aesthetic’
                        </span>
                        - Ryan
                      </li>
                      <li>
                        <span className="bold-text">
                          ‘The aesthetic is just *chefs kiss*’
                        </span>
                        - Mary
                      </li>
                      <li>
                        <span className="bold-text">
                          ‘Such a great idea and design!’
                        </span>
                        - Geoff
                      </li>
                      <li>
                        <span className="bold-text">
                          '..more time with my wife and kids'
                        </span>
                        - Dennis
                      </li>
                      <li>
                        <span className="bold-text">
                          ‘Such a game changer for us iOS folks!’
                        </span>
                        - Mary
                      </li>
                      <li>
                        <span className="bold-text">
                          'I really love it, it looks fantastic'
                        </span>
                        - Rebecca
                      </li>
                      <li>
                        <span className="bold-text">
                          'I just wanted to say how terrific it is...extremely
                          clever..'
                        </span>
                        - Jamie
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className={`reservation_crad_box ${
                  isReservationRoute ? "reservation_page_box" : ""
                }`}
              >
                {/* <div className="card1">
                  <div className="card_icon">
                    <img src={imagesLinks.c1} alt="" />
                  </div>
                  <div className="card_text">
                    <p className="card_p1">
                      Lock in a massive lifetime discount
                    </p>
                    <p className="card_p2">
                      Early bird gets the worm! Offer ends when we launch on the
                      app store.
                    </p>
                  </div>
                </div> */}
                <div className="card1">
                  <div className="card_icon">
                    <img src={imagesLinks.c2} alt="" />
                  </div>
                  <div className="card_text">
                    <p className="card_p1">7-day full refund guarantee</p>
                    <p className="card_p2">
                      Not a fan? No problem. Email us for a full refund within 7
                      days of purchase.
                    </p>
                  </div>
                </div>
                <div className="card1 card-bottom">
                  <div className="card_icon">
                    <img src={imagesLinks.c3} alt="" />
                  </div>
                  <div className="card_text">
                    <p className="card_p1">Payment secured by Stripe</p>
                    <p className="card_p2">
                      The same payment processor Apple, Amazon, Etsy, Walmart &
                      Target use. No credit card details seen or stored by us!
                    </p>
                  </div>
                </div>
                {/* Move the footer_section here if screen width is less than 830px */}
                {isMobileView && (
                  <div className="footer_section">
                    <FooterSection />
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* Render the footer_section normally if screen width is greater than 830px */}
        </div>
        {!isMobileView && (
          <div className="footer_section">
            <FooterSection />
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default ReservationPage;
